__turbopack_context__.v({
  "column": "bira7a_column",
  "columnIsDefault": "bira7a_columnIsDefault",
  "content": "bira7a_content",
  "defaultInfoTagMobile": "bira7a_defaultInfoTagMobile",
  "defaultInfoTagWeb": "bira7a_defaultInfoTagWeb",
  "details": "bira7a_details",
  "noWrap": "bira7a_noWrap",
  "tabletAndWebContent": "bira7a_tabletAndWebContent",
  "title": "bira7a_title",
});
